exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ficheVIsioVente  {\n  width: calc(100% - 26px);\n  margin-left: 6px;\n}\n.ficheVIsioVente .v-text-field__solo {\n  width: calc(100% - 26px);\n}\n.ficheVIsioVente .v-text-field__slot {\n  margin-left: 8px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/watcheebox/WzFichePushProduit.vue
// module id = KpMS
// module chunks = 1